import { Menu, X } from 'lucide-react';
import { useState } from 'react';

interface HeaderProps {
  onNavigateToContact?: () => void;
}

export function Header({ onNavigateToContact }: HeaderProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
    setIsMenuOpen(false); // Close mobile menu after clicking
  };

  const handleNavClick = (e: React.MouseEvent, sectionId: string) => {
    e.preventDefault();
    scrollToSection(sectionId);
  };

  const handleFindSpaceClick = () => {
    if (onNavigateToContact) {
      onNavigateToContact();
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-[#D8D7C8]">
      <nav className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            {/* <div className="w-8 h-8 bg-gradient-to-br from-[#1F473E] to-[#49685E] rounded"></div> */}
            <span className="text-xl text-[#1F473E]">Co-Work@Level 3</span>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button onClick={(e) => handleNavClick(e, 'features')} className="text-[#49685E] hover:text-[#1F473E] transition-colors">Features</button>
            <button onClick={(e) => handleNavClick(e, 'spaces')} className="text-[#49685E] hover:text-[#1F473E] transition-colors">Spaces</button>
            <button onClick={(e) => handleNavClick(e, 'pricing')} className="text-[#49685E] hover:text-[#1F473E] transition-colors">Pricing</button>
            <button onClick={(e) => handleNavClick(e, 'contact')} className="text-[#49685E] hover:text-[#1F473E] transition-colors">Contact</button>
            <button onClick={handleFindSpaceClick} className="px-8 py-3 bg-[#1F473E] text-[#F1ECDC] rounded hover:bg-[#49685E] transition-colors shadow-lg shadow-[#1F473E]/20">
              Find your Space
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-[#1F473E]"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X /> : <Menu />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden pt-4 pb-2 space-y-3">
            <button onClick={(e) => handleNavClick(e, 'features')} className="block text-left text-[#49685E] hover:text-[#1F473E]">Features</button>
            <button onClick={(e) => handleNavClick(e, 'spaces')} className="block text-left text-[#49685E] hover:text-[#1F473E]">Spaces</button>
            <button onClick={(e) => handleNavClick(e, 'pricing')} className="block text-left text-[#49685E] hover:text-[#1F473E]">Pricing</button>
            <button onClick={(e) => handleNavClick(e, 'contact')} className="block text-left text-[#49685E] hover:text-[#1F473E]">Contact</button>
            <button onClick={handleFindSpaceClick} className="w-full px-8 py-3 bg-[#1F473E] text-[#F1ECDC] rounded hover:bg-[#49685E] transition-colors shadow-lg shadow-[#1F473E]/20">
              Find your Space
            </button>
          </div>
        )}
      </nav>
    </header>
  );
}